import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as source from "sources/books/customPointTypes";
import List from "./list";
import Show from "./show";

export default class CustomPoints extends Component {
    componentWillUnmount() {
        this.props.clearParams("custompoints");
    }

    render() {
        const { match, location, history } = this.props;
        const rootUrl = `${match.path}/list`;
        const back = () => history.push(rootUrl);
        return (
            <div className="page-content">
                <Switch location={location}>
                    <Route exact path={`${match.path}/`} render={() => <Redirect to={rootUrl} />} />
                    <Route
                        exact
                        path={rootUrl}
                        render={() => (
                            <List {...this.props} isTable transition="full" title="Список типов точек" nofilter />
                        )}
                    />
                    <Route
                        path={`${rootUrl}/:id`}
                        render={(rest) => (
                            <Show {...rest} transition="full" title="Тип точки" back={back} source={source} />
                        )}
                    />
                </Switch>
            </div>
        );
    }
}
